import type { Hooks, TableInstance } from 'react-table';

import type { SetModalProps } from '../../../../common/CustomModal/useModalProps';

export type TraffickingPageModalCallback = (data: TraffickingPageModalData) => void;

export type TraffickingPageModalData = {
  children: JSX.Element;
};

function makeUseInstance<T extends object>(setPageModal: SetModalProps) {
  return function useInstance(instance: TableInstance<T>): void {
    const openTraffickingPageModal = (data: TraffickingPageModalData): void =>
      setPageModal({ isOpen: true, children: data.children });

    const closeTraffickingPageModal = (): void => setPageModal({ isOpen: false });

    Object.assign(instance, { openTraffickingPageModal, closeTraffickingPageModal });
  };
}

function makePageModalPlugin<T extends object>(setPageModal: SetModalProps) {
  return function usePageModalPlugin(hooks: Hooks<T>): void {
    hooks.useInstance.push(makeUseInstance(setPageModal));
  };
}

export default makePageModalPlugin;
